/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  FormControlLabel,
  FormControlLabelProps,
  Checkbox as MuiCheckbox,
  styled,
} from '@mui/material';
import React, { forwardRef } from 'react';
import { colors } from '@farmlands/mui-theme';
import { shouldForwardProp } from '../util/helpers';

const StyledFormControl = styled(FormControlLabel, {
  shouldForwardProp: (props) => shouldForwardProp(['testId'], props),
})(({ theme, color }) => ({
  '& .MuiFormControlLabel-label': {
    ...theme.typography.body2,
    color: color ?? colors.grey700,
  },
  // Whitebackground to checkbox
  position: 'relative',
  '::before': {
    content: '""',
    left: 14,
    top: 14,
    height: 15,
    width: 15,
    position: 'absolute',
    backgroundColor: 'white',
    zIndex: -1,
  },
  '& .MuiSvgIcon-root': {
    color: color ?? colors.primary500,
  },
}));

type CheckboxProps = Omit<FormControlLabelProps, 'control'> & {
  testId?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
};
export const Checkbox = forwardRef((props: CheckboxProps) => {
  return (
    <StyledFormControl
      {...props}
      control={
        <MuiCheckbox
          data-testid={props.testId}
          data-value={props.checked}
          onChange={props.onChange}
          checked={props.checked}
        />
      }
    />
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
